import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=48952e6f&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48952e6f')) {
      api.createRecord('48952e6f', component.options)
    } else {
      api.reload('48952e6f', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=48952e6f&", function () {
      api.rerender('48952e6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27UopW193o4ot/JS/cancellationPolicy.vue"
export default component.exports